import { render, staticRenderFns } from "./ColumnSaleStatusTecnospeed.vue?vue&type=template&id=06c04ad0&scoped=true"
import script from "./ColumnSaleStatusTecnospeed.vue?vue&type=script&lang=js"
export * from "./ColumnSaleStatusTecnospeed.vue?vue&type=script&lang=js"
import style0 from "./ColumnSaleStatusTecnospeed.vue?vue&type=style&index=0&id=06c04ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c04ad0",
  null
  
)

export default component.exports